var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShare(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 17,
    viewBox: "0 0 15 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.25 11.73C11.6483 11.73 11.11 11.9675 10.6983 12.3396L5.05375 9.05415C5.09333 8.87206 5.125 8.68998 5.125 8.49998C5.125 8.30998 5.09333 8.1279 5.05375 7.94581L10.635 4.69206C11.0625 5.0879 11.6246 5.33331 12.25 5.33331C13.5642 5.33331 14.625 4.27248 14.625 2.95831C14.625 1.64415 13.5642 0.583313 12.25 0.583313C10.9358 0.583313 9.875 1.64415 9.875 2.95831C9.875 3.14831 9.90667 3.3304 9.94625 3.51248L4.365 6.76623C3.9375 6.3704 3.37542 6.12498 2.75 6.12498C1.43583 6.12498 0.375 7.18581 0.375 8.49998C0.375 9.81415 1.43583 10.875 2.75 10.875C3.37542 10.875 3.9375 10.6296 4.365 10.2337L10.0017 13.5271C9.96208 13.6933 9.93833 13.8675 9.93833 14.0416C9.93833 15.3162 10.9754 16.3533 12.25 16.3533C13.5246 16.3533 14.5617 15.3162 14.5617 14.0416C14.5617 12.7671 13.5246 11.73 12.25 11.73Z",
    fill: "#0F0F22"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.6b3edea77b4e23ae1edbaf85126ae7a1.svg";
export { ForwardRef as ReactComponent };